
import { useAuth0 } from "@auth0/auth0-react";
import React from 'react';
import { Alert, Button, Row, Col } from 'reactstrap';

const LoginHandler = (props) => {
  const { error } = useAuth0();

  // if there is a login error... show it
  if (error) {
    return (
      <Row style={{padding: 20}}>
        <Col>
          <Row>
            <Col>
              <Alert color="danger">
                {error.message}
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                onClick={() => window.location.href="/"}
              >
                Go to home
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  return props.children;
};

export default LoginHandler;